import api from './api';

export const consultarHistoricosCadastro = params =>
  api.get('/HistoricoCadastro', { params });

export const obterDetalheHistoricoCadastro = (entidade, id) =>
  api.get(`/HistoricoCadastro/${entidade}/${id}`);
